// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

export const ROOT = '/app';

// ----------------------------------------------------------------------

export const PATHS = {
  root: ROOT,
  dashboard: path(ROOT, '/dashboard'),
  account: path(ROOT, '/account'),
  newProduct: path(ROOT, '/products/new'),
  warehouse: path(ROOT, '/warehouse/list'),
  orders: path(ROOT, '/orders'),
  createOrders: path(ROOT, '/create-orders'),
  newOrder: path(ROOT, '/orders/new'),
  canceledOrders: path(ROOT, '/cancel-orders'),
  cancelOrderProcess: path(ROOT, '/cancel-orders/:id'),
  orderDetail: path(ROOT, '/orders/:id/detail'),
  ordersHistory: path(ROOT, '/order-history'),
  multiOrders: path(ROOT, '/multi-orders'),
  products: path(ROOT, '/products'),
  pickOrder: path(ROOT, '/orders/:id/pick'),
  packOrder: path(ROOT, '/orders/:id/pack'),
  multiPick: path(ROOT, '/orders/multi-pick'),
  receptions: path(ROOT, '/receptions'),
  receptionsHistory: path(ROOT, '/reception-history'),
  newReception: path(ROOT, '/receptions/new'),
  storeReception: path(ROOT, '/receptions/:id/store'),
  clients: path(ROOT, '/clients'),
  createClients: path(ROOT, '/create-client'),
  clientSettings: path(ROOT, '/clients/:id/settings'),
  recollectOrders: path(ROOT, '/recollect-orders'),
  pickRecolectOrder: path(ROOT, '/recollect-orders/:id/pick'),
  historyRecollectOrders: path(ROOT, '/recollect-history'),
  newPickRecollectOrder: path(ROOT, '/recollect-orders/new'),
  financialState: path(ROOT, '/financial-state'),
  locations: path(ROOT, '/locations'),
  cycleCount: path(ROOT, '/locations/:id/cycle-count'),
  postalCodes: path(ROOT, '/postal-codes'),
  packaged: path(ROOT, '/packaged'),
  reports: path(ROOT, '/reports'),
  integrations: path(ROOT, '/integrations'),
  page404: '/404',
  login: '/login'
};
